import React, { Component } from 'react';
import { Button } from "@material-ui/core";
import { EmojiObjectsOutlined, TouchAppOutlined } from "@material-ui/icons";
import  Footer from '../Footer/footer';
class contactContainer extends Component {
    constructor (props) {
      super(props);
      this.state = {
        formUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdAMprvOVE3YEEw1q-37_H5ueIVCaXCo2AKlJkiPLvn5pcQAg/viewform?usp=sf_link"
      };
    }
    
    render() {
      return (
        <div className="container-contact" >
          <h4 className="contact-title"><EmojiObjectsOutlined className="contact-fill"></EmojiObjectsOutlined> Have an awesome idea?</h4>
            <div className="contact">
              <Button className="contact-btn" href={this.state.formUrl} target="_blank" rel="noopener noreferrer"><TouchAppOutlined className="contact-fill"></TouchAppOutlined> Contact</Button>
            </div>
            <Footer/>
        </div>
        )
    }
};

export default contactContainer;